<template>
  <div>
    <jobs-header />
    <jobs-page v-if="jobsfound>0" :location="location" :company="company" :industry="industry" :role="role" :jobs="jobs" :jobsfound="jobsfound" :error="error" :featuredCompanies="featuredCompanies"/>
    <jobs-footer />
  </div>
</template>

<script>
import JobsPage from './JobsPage'
import { publicProfilesUrl } from './settings'
import { industries } from './utils/filters'
import JobsHeader from './JobsHeader'
import JobsFooter from './JobsFooter'

export default {
  data () {
    return {
      location: '',
      company: '',
      industry: '',
      role: '',
      search: '',
      jobs: [],
      jobsfound: 0,
      error: '',
      featuredCompanies: []
    }
  },
  async mounted () {
    // eslint-disable-next-line no-undef
    const queryParams = query
    if (queryParams.includes('_')) {
      this.location = queryParams.split('_')[0]
      this.company = queryParams.split('_')[1] ? queryParams.split('_')[1] : ''
      this.role = queryParams.split('_')[2] ? queryParams.split('_')[2] : ''
      this.role = this.role.replace('-', ' ')
      if (industries.includes(this.role)) {
        this.industry = this.role
        this.search = `&industry=${this.industry}`
        this.role = ''
      } else {
        this.search = `&role=${this.role}`
      }
    } else {
      this.location = queryParams
    }
    const fetch = require('node-fetch')
    const featuredCompaniesResult = await fetch(`${publicProfilesUrl}/api/featuredCompanies`, {
    // const featuredCompaniesResult = await fetch(`http://localhost:3000/api/featuredCompanies`, {
      method: 'get',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
    this.featuredCompanies = await featuredCompaniesResult.json()
    const queryUrl = `${publicProfilesUrl}/api/jobs?location=${this.location}${this.search}&company=${this.company}`
    const result = await fetch(queryUrl, {
      method: 'get',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
    const jobsDocs = await result.json()
    this.jobs = jobsDocs.result.response.docs
    this.jobsfound = jobsDocs.result.response.numFound
    this.error = false
  },
  head () {
    let location = ''
    if (typeof this.location === 'string') {
      location = this.location.charAt(0).toUpperCase() + this.location.slice(1)
    }
    let title = 'Flexible working jobs, remote working, flexitime, job shares'
    let description = 'DuoMe helps you work flexibly, search for Job Shares, Remote Working, Part Time or Flexitime. Find the flexible job you want.'
    if (this.location && this.role) {
      title = `Flexible working ${this.role} jobs in ${location}`
      description = `DuoMe helps you work flexibly, search for Job Shares, Part Time or Flexitime ${this.role} Jobs near ${location}. Find the flexible job you want.`
    } else if (this.location) {
      title = `Flexible working jobs, remote working, job shares in ${location}`
      description = `DuoMe helps you work flexibly, search for Job Shares, Remote Working, Part Time or Flexitime in ${location}. Find the flexible job you want.`
    } else if (this.role) {
      title = `Flexible working ${this.role} jobs, remote working, job shares`
      description = `DuoMe helps you work flexibly in ${this.role}, search for Job Shares, Remote Working, Part Time or Flexitime. Find the flexible job you want.`
    }

    return {
      title: title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'ogType', property: 'og:type', content: 'website' },
        { hid: 'fbAppId', property: 'fb:app_id', content: '521660045022515' },
        { hid: 'ogTitle', property: 'og:title', content: title },
        { hid: 'ogDesc', property: 'og:description', content: description }
      ]
    }
  },
  components: {
    JobsPage,
    JobsHeader,
    JobsFooter
  }
}
</script>
